import * as React from 'react'

import { IItemCard } from '../interface'

import LockupAttributes from '../lockupAttributes'
import LockupFilesIncluded from '../lockupFilesIncluded'

import CommonItemCardLayout from '../commonItemCardLayout'

const CodeCanyonItemCard = (props: IItemCard) => {
  return (
    <CommonItemCardLayout {...props}>
      <LockupAttributes {...props} />
      <LockupFilesIncluded {...props} />
    </CommonItemCardLayout>
  )
}

export default CodeCanyonItemCard
